
import HotspotMixin from '@owc-utils/Mixins/HotspotMixin';
import { HotspotPanoramaItemComponent } from './HotspotPanoramaItem';
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';

export default (ComponentInitializeDispatcher as HotspotPanoramaItemComponent).extend({
  name: 'owc-hotspot-panorama-item',
  components: {
    ValidationBoxWrapper,
  },
  mixins: [HotspotMixin],
  props: {
    hotspotText: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isActive: false,
    isHover: false,
  }),
  mounted() {
    this.addHotspotChangeListener(this.componentId, this.toggleActiveFlag);
  },
  beforeDestroy() {
    this.removeHotspotChangeListener(this.componentId, this.toggleActiveFlag);
  },
  methods: {
    onHotspotItemClick() {
      if (this.isActive) {
        this.setActiveHotspotId(this.componentParentId, null);
      } else {
        if (this.componentId) {
          this.setActiveHotspotId(this.componentParentId, this.componentId);
        } else {
          throw new Error('missing component id');
        }
      }
    },
    activate() {
      this.isActive = true;
    },
    deactivate() {
      this.isActive = false;
    },
    toggleActiveFlag(state) {
      if (this.componentParentId) {
        const parentActiveItemId = state.activeItemsMap[this.componentParentId];

        // Active item id is deliberately set to null, deactivate
        if (parentActiveItemId === null && this.isActive) {
          this.deactivate();
          return;
        }

        // Active item id exists for the given parent
        if (parentActiveItemId) {
          if (parentActiveItemId === this.componentId) {
            this.activate();
          } else {
            this.deactivate();
          }
        }
      }
    },
  },
});
